import { lazy } from 'react';

/** Загружает страницу прикладных настроек */
export const VoxSettingsPageAsync = lazy(() => import('./VoxSettingsPage'));
